import sanitizeHtml from 'sanitize-html';

export const sanitizeContent = (content, options = {}) =>
	sanitizeHtml(content, options);
